export default "__VITE_ASSET__c038cc59__"